export default __webpack_public_path__ + "static/media/de_hosarim.f59ad668.csv";